
import { useEffect, useState } from "react";
import {
    Transaction,
    SystemProgram,
    Connection,
    PublicKey,
    LAMPORTS_PER_SOL
} from '@solana/web3.js';
import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import axios from "axios";
import { toast } from "sonner";


export function useMakePayment(amount) {
    const [vault, setVault] = useState(null)
    const [transaction, setTransaction] = useState(null)

    const { connection } = useConnection();
    const { sendTransaction, connected, publicKey } = useWallet()

    useEffect(() => {
        let endpoint = process.env.REACT_APP_VAULT_ENDPOINT
        connected && endpoint && getVault(endpoint)
    }, [connected])

    const getVault = async (endpoint) => {
        try {
            const vault = await axios.get(endpoint, {
                headers: {
                    walletAddress: publicKey.toBase58()
                }
            }).then((res) => res.data)

            setVault(vault)

        } catch (error) {
            console.error("Transaction failed", error);
        }
    }

    const ConfirmTransaction = async (signature) => {
        let done = false;
        let status = null;
        let confirmed = false
        // Polling for the status of the transaction
        while (!done) {
            // Get the transaction status
            status = await connection.getSignatureStatus(signature);
            if (status && status.value) {
                if (!confirmed && status.value.confirmationStatus === 'confirmed') {
                    toast('transaction confirmed ! Finalizing transaction please wait ...', { duration: 6000 })
                    confirmed = true
                }
                // If the transaction is finalized
                if (status.value.confirmationStatus === 'finalized') {
                    done = true;
                    setTransaction(signature)
                    return true; // Transaction finalized successfully
                }
                // If the transaction was reverted (failed or encountered an error)
                if (status.value.err) {
                    console.error("Transaction failed or reverted:", status.value.err);
                    toast.error('transaction failed')
                    done = true;
                    return false; // Transaction failed or reverted
                }
            }
            // Sleep for a short duration before polling again
            await new Promise(resolve => setTimeout(resolve, 1000));
        }
        return false; // In case of unexpec
    };

    const pay = async (amount) => {
        if (amount >= 0.1) {
            try {
                const vaultKey = new PublicKey(vault);
                const transaction = new Transaction();
                const sendSolInstruction = SystemProgram.transfer({
                    fromPubkey: publicKey,
                    toPubkey: vaultKey,
                    lamports: amount * LAMPORTS_PER_SOL,
                });
                transaction.add(sendSolInstruction);
                toast('creating transaction Please Approve ...')
                const signature = await sendTransaction(transaction, connection);
                const confirmed = await ConfirmTransaction(signature)

                if (confirmed) {
                    setTransaction(signature)
                    return signature
                } else {
                    setTransaction(false)
                    return false
                }
            } catch (error) {
                toast(error.message)

            }
        }
    }


    return { pay, vault, transaction, publicKey, connection }

}